import { put, select } from 'redux-saga/effects';
import { ClientBetsType, IMakeBet } from 'widgets/Roulette/types';
import { placeBetAction } from 'core/widgets/RouletteBet/actions';
import { placedBetSelector } from 'core/widgets/RouletteBet/selectors';
import { betsToBetsArray } from 'widgets/Roulette/helpers';

export function* doubleBetSaga() {
  const { present }: ClientBetsType = yield select(placedBetSelector);
  // @ts-ignore
  const bets: IMakeBet[] = betsToBetsArray(present);
  yield put(placeBetAction({ bets, double: true }));
}
